import React, { useState, useEffect, useRef } from 'react';
import { Navigation, Autoplay } from 'swiper/modules';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

const getYearFromBatch = (batch) => {
    if (!batch) return 0;
    return parseInt(batch.split(' ')[0], 10);
};


const AvatarIcon = ({ name, color }) => {
    return (
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 200 200"
            style={{ display: 'block', backgroundColor: color }}
        >
            <circle cx="100" cy="100" r="100" fill={color} />
            <circle cx="100" cy="70" r="32" fill="#ffffff" />
            <ellipse cx="100" cy="145" rx="48" ry="32" fill="#ffffff" />
        </svg>
    );
};


const getAvatarColor = (name) => {
    const colors = ['#f09e06', '#3b82f6', '#8b5cf6', '#10b981', '#ef4444', '#6366f1', '#ec4899'];
    const index = name ? name.charCodeAt(0) % colors.length : 0;
    return colors[index];
};

export default function AdvisoreCouncil() {
    const swiperRef = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(1);

    const advisoryCouncilData = [
        // {
        //     name: "RANJIT KUMAR SENGUPTA",
        //     batch: "1964 CE",
        //     mobile: "9433773731",
        //     email: "ranjitsengupta72@gmail.com",
        //     image: null
        // },
        // {
        //     name: "ACHYUT GHOSH",
        //     batch: "1961 ME",
        //     mobile: "9836573143",
        //     email: "ghosh.achyut@gmail.com",
        //     image: null
        // },
        // {
        //     name: "SYAMA PRASAD DATTA",
        //     batch: "1967 CE",
        //     mobile: "9830292214",
        //     email: "spdatta1@gmail.com",
        //     image: null
        // },
        // {
        //     name: "JIBAN KUMAR CHAUDHURY",
        //     batch: "1968 EE",
        //     mobile: "9331823851",
        //     email: "chaudhuryjk@yahoo.com",
        //     image: null
        // },
        // {
        //     name: "SISIR KUMAR PAUL",
        //     batch: "1968 CE",
        //     mobile: "9830750090",
        //     email: "ultra123@dataone.in",
        //     image: null
        // },
        // {
        //     name: "SHYAMAL KUMAR MITRA",
        //     batch: "1967 CE",
        //     mobile: "9903072403",
        //     email: "skma33@gmail.com",
        //     image: null
        // },
        // {
        //     name: "DIPTA SUNDAR MALLICK",
        //     batch: "1974 ME",
        //     mobile: "9331823840",
        //     email: "dsmallick53@gmail.com",
        //     image: null
        // }

        {
            name: "Mr Achyut Ghosh",
            batch: "",
            mobile: "",
            email: "",
            image: null
        },
        {
            name: "Mr Dibakar Ghosh",
            batch: "1968 CE",
            mobile: "",
            email: "",
            image: null
        },
        {
            name: "Mr Sisir Kr. Paul",
            batch: "",
            mobile: "",
            email: "",
            image: null
        },
        {
            name: "Mr Jiban Kr Chowdhury",
            batch: "",
            mobile: "",
            email: "",
            image: null
        },
        {
            name: "Mr Syamaprasad Dutta",
            batch: "",
            mobile: "",
            email: "",
            image: null
        },
        {
            name: "Mr Shyamal Kr Mitra",
            batch: "",
            mobile: "",
            email: "",
            image: null
        },
        {
            name: "Mr Dipta Sunder Mallik",
            batch: "",
            mobile: "",
            email: "",
            image: null
        },
        
    ];

const [members] = useState(
    [...advisoryCouncilData].sort(
        (a, b) => getYearFromBatch(b.batch) - getYearFromBatch(a.batch)
    )
);
    const totalSlides = members.length;


    useEffect(() => {
        if (!swiperRef.current || members.length === 0) return;

        const swiper = new Swiper('.advisory-member-active', {
            modules: [Navigation],
            navigation: {
                nextEl: '.adv-swiper-button-next',
                prevEl: '.adv-swiper-button-prev'
            },
            loop: members.length > 3,
            slidesPerView: 3,
            spaceBetween: 30,
            speed: 800,
              watchOverflow: false,

            breakpoints: {
                1400: { slidesPerView: 4 },
                1200: { slidesPerView: 4 },
                992: { slidesPerView: 3 },
                768: { slidesPerView: 2 },
                576: { slidesPerView: 2 },
                0: { slidesPerView: 1 }
            }
        });

        swiper.on('slideChange', () => {
            setCurrentSlide(swiper.realIndex + 1);
        });

        return () => {
            if (swiper) swiper.destroy();
        };
    }, [members]);

    return (
        <>
            <section className="new-member-slider py-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9 heading text-center">
                            <h2>Advisory Council</h2>
                            <p>The Advisory Council of the B E College Ex-Students' Club comprises senior alumni and respected members who provide guidance on the Club's vision, activities, and growth.</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="swiper advisory-member-active" ref={swiperRef}>
                                <div className="swiper-wrapper">
                                    {members.map((member, index) => {
                                        const memberName = member.name || 'Unknown Member';
                                        const avatarColor = getAvatarColor(memberName);
                                        const imageUrl = member.image;

                                        return (
                                            <div className="swiper-slide" key={index} style={{ height: 'auto' }}>
                                                <div className="item" style={{
                                                    background: 'linear-gradient(180deg, #fff 0%, #f0f7ff 100%)',
                                                    borderRadius: '16px',
                                                    padding: '30px 20px',
                                                    textAlign: 'center',
                                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                                    height: '100%',
                                                    minHeight: '420px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center'
                                                }}>
                                                    {/* Circular Image Container */}
                                                    <div style={{
                                                        width: '200px',
                                                        height: '200px',
                                                        borderRadius: '50%',
                                                        overflow: 'hidden',
                                                        marginBottom: '20px',
                                                        border: '5px solid #fff',
                                                        boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                                                        flexShrink: 0
                                                    }}>
                                                        {imageUrl ? (
                                                            <img
                                                                src={imageUrl}
                                                                alt={memberName}
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    objectFit: 'cover',
                                                                    objectPosition: 'center top'
                                                                }}
                                                                onError={(e) => {
                                                                    e.target.style.display = 'none';
                                                                    e.target.nextSibling.style.display = 'block';
                                                                }}
                                                            />
                                                        ) : null}
                                                        <div style={{ display: imageUrl ? 'none' : 'block', width: '100%', height: '100%' }}>
                                                            <AvatarIcon name={memberName} color={avatarColor} />
                                                        </div>
                                                    </div>

                                                    {/* Batch Badge */}
                                                    <span style={{
                                                        display: 'inline-block',
                                                        backgroundColor: '#f09e06',
                                                        color: '#fff',
                                                        padding: '5px 15px',
                                                        borderRadius: '20px',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        marginBottom: '12px'
                                                    }}>{member?.batch || 'Advisory'}</span>

                                                    {/* Name */}
                                                    <h3 style={{
                                                        fontSize: '18px',
                                                        fontWeight: '700',
                                                        color: '#1a1a2e',
                                                        marginBottom: '15px',
                                                        lineHeight: '1.3'
                                                    }}>{memberName}</h3>

                                                    {/* Contact Info
                                                    <p style={{
                                                        fontSize: '14px',
                                                        color: '#555',
                                                        margin: '0 0 5px 0'
                                                    }}><strong>Mobile:</strong> {member?.mobile || 'N/A'}</p>
                                                    <p style={{
                                                        fontSize: '13px',
                                                        color: '#555',
                                                        margin: 0,
                                                        wordBreak: 'break-all'
                                                    }}><strong>Email:</strong> {member?.email || 'N/A'}</p> */}  
                                                    
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="swiper-navigation">
                                <div className="adv-swiper-button-prev custom-prev"></div>
                                <div className="member-counter">
                                    <span id="current-slide">{currentSlide}</span> / <span id="total-slide" style={{ color: '#f09e06', fontSize: '20px' }}>{totalSlides}</span>
                                </div>
                                <div className="adv-swiper-button-next custom-next"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
